// extracted by mini-css-extract-plugin
export default {"switch":"switch_switch__GxTl-","on":"switch_on__X1Qz-","button":"switch_button__1JYMS"};